import * as React from "react";

import { navComplete } from "@origin-digital/event-dispatcher";

import { Success } from "src/components/Success";

import content from "./content.json";

export const SuccessScreen = () => (
  <Success {...content} navComplete={navComplete.profileEmail} />
);
